import React, { useEffect, useState } from "react";
import { Form, Col, Row, Modal } from "react-bootstrap";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import Button from "../../../components/Button";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { getDriverNameLink } from "../../../utils/Standings";
import { Link } from "react-router-dom";
import Flag from "../../../components/Flag";
import { useTranslation } from "react-i18next";

const EditDiscordMessage = () => {
  const { t } = useTranslation();
  const { access } = useIsAdmin();
  document.title = "LVF1 - Edit Discord Message";
  const token = window.localStorage.getItem("userLogged");
  const { user } = useUser() as any;
  const [description, setDescription] = useState("");
  const [messageID, setMessageID] = useState("");
  const [flagCode, setFlagCode] = useState("");
  const [channel, setChannel] = useState("1");
  const [title, setTitle] = useState("");
  const [image, setImage] = useState<File | null>(null);

  const editMessage = async () => {
    if (token == null) return;

    const url =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";

    const formData = new FormData();

    formData.append("description", description);
    formData.append("channel", channel);
    formData.append("messageID", messageID);
    formData.append("user", user);
    formData.append("title", title);
    formData.append("flagCode", flagCode);
    formData.append("token", JSON.parse(token).token);

    // 👇 usa tu STATE correcto
    if (image) {
      const base64 = await fileToBase64(image);
      formData.append("image", base64);
    }

    axios
      .post(`${url}/api/admin/updateMessageDiscord`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const result = response.data;
        if (result === "OK") {
          toast.success("Message updated successfully");
        } else {
          toast.error(result);
        }
      })
      .catch((error) => {
        console.error("Error:", error.response || error);
      });
  };

  const fileToBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
    });

  if (!access) return <ErrorPage />;

  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Edit Discord Message" />
        <Form noValidate>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="4">
              <Form.Label>Channel (*)</Form.Label>
              <Form.Select
                value={channel}
                name="channel"
                required
                onChange={(e) => setChannel(e.target.value)}
              >
                <option value="1">ANNOUNCEMENTS_F1</option>
                <option value="3">ANNOUNCEMENTS_RALLY</option>
                <option value="4">ANNOUNCEMENTS_GRAL</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="5">
              <Form.Label>Message ID (*)</Form.Label>
              <Form.Control
                required
                type="number"
                value={messageID}
                onChange={(e) => setMessageID(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="3">
              <Form.Label>Flag code</Form.Label>
              <Form.Control
                required
                type="string"
                value={flagCode}
                onChange={(e) => setFlagCode(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>
                Image (Avoid uploading heavy images to prevent errors.)
              </Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (file) setImage(file);
                }}
              />
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Title</Form.Label>
              <textarea
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Description</Form.Label>
              <textarea
                rows={10}
                className="form-control"
                value={description}
                placeholder={`🏆 **Race Results**  
[LINK]

📓 **Standings**  
[LINK]

🔴 **Next Race**  
Las Vegas · Race · 30 May`}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
          </Row>

          <div className="text-center">
            <Button text={"Update Message"} onClick={() => editMessage()} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default EditDiscordMessage;
